// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalContainer_JTQ3H {
	background: var(--white-color);
	height: 100%;
	min-width: 400px;
	max-width: 500px;
	min-height: 550px;
	border-radius: 6px;
	position: relative;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	display: flex;
	overflow: hidden;
	padding: 0;
}
.modalScrollableContainer_uJPpl {
	overflow-y: auto;
	position: relative;
	flex-direction: column;
	display: flex;
	width: 100%;
	height: 100%;
	gap: 5px;
	align-items: flex-start;
	justify-content: flex-start;
	overflow-x: hidden;
}



.icon_Qu1g_ {
	font-size: 18px;
	color: #5f6368;
	cursor: pointer;
}

.icon_Qu1g_:hover {
	color: #4d4f52;
}

.inputContainer_lhjHz {
	display: flex;
	width: 100%;
	position: relative;
	align-items: center;
	justify-content: center;
}

.input_kfBg9 {
	width: 96%;
	padding: 4px 0;
	border: none;
	border-bottom: 1px solid #d1d1d1;
	outline: none;
	font-size: 22px;
	background: transparent;
	font-weight: 500;
	color: #6e6e6e;
}

.input_kfBg9::placeholder {
	color: #6e6e6e;
}

.underline_GqP0s {
	position: absolute;
	bottom: 0;
	width: 0;
	width: 0%;
	height: 2px;
	background: var(--_16c0982e-background);
	transition: width 0.3s ease;
}

.focused_Mgjng {
	border-bottom-color: transparent;
}

.active_kieyC {
	width: 96%;
}

.toggleOptions__tgB0 {
	display: flex;
	gap: 8px;
	padding: 0px 5px;
	width: 100%;
	align-items: center;
	justify-content: flex-start;
	font-weight: 600;
	overflow-y: auto;
	font-family: Inter;
	font-size: 14px;
	color: #666;
	margin-bottom: 5px;
	scrollbar-width: none;
	min-height: 40px;
}

.toggleOptions__tgB0::-webkit-scrollbar {
	display: none;
}

.option_Rbh4j {
	padding: 8px 10px;
	-webkit-user-select: none;
	        user-select: none;
	border-radius: 4px;
	text-wrap: nowrap;
	cursor: pointer;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;
}

.option_Rbh4j:hover {
	background-color: #f5f5f5;
	color: #666;
}

.option_Rbh4j:active {
	color: var(--_10a37f-background);
	background: var(--_16c0982e-background);
}

.selected_ORVZe {
	color: var(--_10a37f-background);
	background: var(--_16c0982e-background);
}

.selected_ORVZe:hover,
.selected_ORVZe:active {
	color: var(--_10a37f-background);
	background: var(--_16c0982e-background);
}

.buttons_WOtOD {
	display: inline-flex;
	align-items: center;
	justify-content: flex-end;
	gap: 20px;
	margin-top: auto;
	margin-left: auto;
	padding-bottom: 10px;
	padding-right: 10px;
	button {
		outline: none;
		border: none;
		background: transparent;
		color: var(--_10a37f-background);
		padding: 8px 16px;
		border-radius: 6px;
		font-size: 16px;
		font-weight: 600;
		font-family: inherit;
		&.save_iwtH6 {
			background: var(--_10a37f-background);
			color: var(--white-color);
		}
	}
}

.headerCardContaier_gxAEC{
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;

}

.greenAndBold_PHLeC{
	color:#0B745A;
	font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/EventCreationPopUp.module.css"],"names":[],"mappings":"AAAA;CACC,8BAA8B;CAC9B,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,sBAAsB;CACtB,uBAAuB;CACvB,2BAA2B;CAC3B,kBAAkB;CAClB,aAAa;CACb,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,sBAAsB;CACtB,aAAa;CACb,WAAW;CACX,YAAY;CACZ,QAAQ;CACR,uBAAuB;CACvB,2BAA2B;CAC3B,kBAAkB;AACnB;;;;AAIA;CACC,eAAe;CACf,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,UAAU;CACV,cAAc;CACd,YAAY;CACZ,gCAAgC;CAChC,aAAa;CACb,eAAe;CACf,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,SAAS;CACT,WAAW;CACX,uCAAuC;CACvC,2BAA2B;AAC5B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,gBAAgB;CAChB,WAAW;CACX,mBAAmB;CACnB,2BAA2B;CAC3B,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,yBAAiB;SAAjB,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf;;iBAEgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,gCAAgC;CAChC,uCAAuC;AACxC;;AAEA;CACC,gCAAgC;CAChC,uCAAuC;AACxC;;AAEA;;CAEC,gCAAgC;CAChC,uCAAuC;AACxC;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,yBAAyB;CACzB,SAAS;CACT,gBAAgB;CAChB,iBAAiB;CACjB,oBAAoB;CACpB,mBAAmB;CACnB;EACC,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB;GACC,qCAAqC;GACrC,yBAAyB;EAC1B;CACD;AACD;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;;AAEZ;;AAEA;CACC,aAAa;CACb,iBAAiB;AAClB","sourcesContent":[".modalContainer {\n\tbackground: var(--white-color);\n\theight: 100%;\n\tmin-width: 400px;\n\tmax-width: 500px;\n\tmin-height: 550px;\n\tborder-radius: 6px;\n\tposition: relative;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tposition: relative;\n\tdisplay: flex;\n\toverflow: hidden;\n\tpadding: 0;\n}\n.modalScrollableContainer {\n\toverflow-y: auto;\n\tposition: relative;\n\tflex-direction: column;\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 100%;\n\tgap: 5px;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\toverflow-x: hidden;\n}\n\n\n\n.icon {\n\tfont-size: 18px;\n\tcolor: #5f6368;\n\tcursor: pointer;\n}\n\n.icon:hover {\n\tcolor: #4d4f52;\n}\n\n.inputContainer {\n\tdisplay: flex;\n\twidth: 100%;\n\tposition: relative;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.input {\n\twidth: 96%;\n\tpadding: 4px 0;\n\tborder: none;\n\tborder-bottom: 1px solid #d1d1d1;\n\toutline: none;\n\tfont-size: 22px;\n\tbackground: transparent;\n\tfont-weight: 500;\n\tcolor: #6e6e6e;\n}\n\n.input::placeholder {\n\tcolor: #6e6e6e;\n}\n\n.underline {\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 0;\n\twidth: 0%;\n\theight: 2px;\n\tbackground: var(--_16c0982e-background);\n\ttransition: width 0.3s ease;\n}\n\n.focused {\n\tborder-bottom-color: transparent;\n}\n\n.active {\n\twidth: 96%;\n}\n\n.toggleOptions {\n\tdisplay: flex;\n\tgap: 8px;\n\tpadding: 0px 5px;\n\twidth: 100%;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tfont-weight: 600;\n\toverflow-y: auto;\n\tfont-family: Inter;\n\tfont-size: 14px;\n\tcolor: #666;\n\tmargin-bottom: 5px;\n\tscrollbar-width: none;\n\tmin-height: 40px;\n}\n\n.toggleOptions::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.option {\n\tpadding: 8px 10px;\n\tuser-select: none;\n\tborder-radius: 4px;\n\ttext-wrap: nowrap;\n\tcursor: pointer;\n\ttransition:\n\t\tbackground-color 0.3s ease,\n\t\tcolor 0.3s ease;\n}\n\n.option:hover {\n\tbackground-color: #f5f5f5;\n\tcolor: #666;\n}\n\n.option:active {\n\tcolor: var(--_10a37f-background);\n\tbackground: var(--_16c0982e-background);\n}\n\n.selected {\n\tcolor: var(--_10a37f-background);\n\tbackground: var(--_16c0982e-background);\n}\n\n.selected:hover,\n.selected:active {\n\tcolor: var(--_10a37f-background);\n\tbackground: var(--_16c0982e-background);\n}\n\n.buttons {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tgap: 20px;\n\tmargin-top: auto;\n\tmargin-left: auto;\n\tpadding-bottom: 10px;\n\tpadding-right: 10px;\n\tbutton {\n\t\toutline: none;\n\t\tborder: none;\n\t\tbackground: transparent;\n\t\tcolor: var(--_10a37f-background);\n\t\tpadding: 8px 16px;\n\t\tborder-radius: 6px;\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tfont-family: inherit;\n\t\t&.save {\n\t\t\tbackground: var(--_10a37f-background);\n\t\t\tcolor: var(--white-color);\n\t\t}\n\t}\n}\n\n.headerCardContaier{\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n\n}\n\n.greenAndBold{\n\tcolor:#0B745A;\n\tfont-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `modalContainer_JTQ3H`,
	"modalScrollableContainer": `modalScrollableContainer_uJPpl`,
	"icon": `icon_Qu1g_`,
	"inputContainer": `inputContainer_lhjHz`,
	"input": `input_kfBg9`,
	"underline": `underline_GqP0s`,
	"focused": `focused_Mgjng`,
	"active": `active_kieyC`,
	"toggleOptions": `toggleOptions__tgB0`,
	"option": `option_Rbh4j`,
	"selected": `selected_ORVZe`,
	"buttons": `buttons_WOtOD`,
	"save": `save_iwtH6`,
	"headerCardContaier": `headerCardContaier_gxAEC`,
	"greenAndBold": `greenAndBold_PHLeC`
};
export default ___CSS_LOADER_EXPORT___;
